import { useMutation } from "@tanstack/react-query";
import { PagedUserModel } from "../../../../main/users-facility/api/types";
import { usePost } from "../../../api-service";
import useUserInvStore from "./store";
import { UserFormSchema } from "./schema";
import { dummyPagedUserModel } from "../../../../main/user-management/api/walkthrough";

export const useGetPagedUsersByEmail = (walkthroughMode: boolean) => {
  const { post } = usePost();
  const { pageNumber, pageSize, queryData, facilityCode, productCode } = useUserInvStore();

  const facilityParam = facilityCode ? `&FacilityCode=${facilityCode}` : "";
  const productParam = productCode ? `&ProductCode=${productCode}` : "";
  const url = `/api/users/by-email?PageNumber=${pageNumber}&PageSize=${pageSize}&Email=${queryData.email}${facilityParam}${productParam}`;
  return useMutation({
    mutationFn: () => {
      if (walkthroughMode) {
        return Promise.resolve(dummyPagedUserModel);
      }
      return post<undefined, PagedUserModel>(url, undefined, false);
    },
  });
};

export const useGetPagedUsersByName = () => {
  const { post } = usePost();
  const { queryData, pageNumber, pageSize, facilityCode, productCode } = useUserInvStore();

  const facilityParam = facilityCode ? `&FacilityCode=${facilityCode}` : "";
  const productParam = productCode ? `&ProductCode=${productCode}` : "";
  const url = `/api/users/by-name?PageNumber=${pageNumber}&PageSize=${pageSize}&FirstName=${queryData.firstName}&LastName=${queryData.lastName}${facilityParam}${productParam}`;
  return useMutation({
    mutationFn: () => {
      return post<undefined, PagedUserModel>(url, undefined, false);
    },
    onSuccess: (data) => {
      //  setValue("token", data);
    },
  });
};

export const useCreateFacilityUser = () => {
  const { post } = usePost();
  return useMutation({
    mutationFn: async (data: UserFormSchema) => {
      const formData = convertUserFormSchemaToFormData(data);
      return post(`/api/users/facility-user`, formData, true, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
  });
};

const convertUserFormSchemaToFormData = (data: UserFormSchema): FormData => {
  const formData = new FormData();

  formData.append("Email", data.email);
  formData.append("FirstName", data.firstName);
  formData.append("LastName", data.lastName);
  if (data.birthDate) formData.append("BirthDate", data.birthDate);
  formData.append("Role.Role", data.role.role.toString());
  formData.append("Role.Id", data.role.id);
  if (data.id) formData.append("Id", data.id);
  if (data.civilStatus)
    formData.append("CivilStatus", data.civilStatus.toString());
  if (data.gender) formData.append("Gender", data.gender.toString());
  if (data.productCode) formData.append("ProductCode", data.productCode);
  if (data.facilityCode) formData.append("FacilityCode", data.facilityCode);
  if (data.prefix) formData.append("Prefix", data.prefix);
  if (data.suffix) formData.append("Suffix", data.suffix);
  if (data.customName) formData.append("CustomName", data.customName);
  if (data.middleName) formData.append("MiddleName", data.middleName);
  if (data.photoUrl) formData.append("UserPhoto", data.photoUrl);

  return formData;
};
